import styled from 'styled-components';
import { FlexBetween } from '../../../styled/common';

export const SectionHeaderContainer = styled(FlexBetween)`
  padding-bottom: 26px;
  border-bottom: 1px solid
    ${({ theme: { colors } }) => colors.border.primaryReverse};
  margin-bottom: 40px;

  @media (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
    flex-direction: column;
    padding-bottom: 16px;
    align-items: flex-start;
  }
`;

export const Title = styled.div`
  font-size: 32px;
  color: ${({ theme: { colors } }) => colors.text.tertiary};

  @media (max-width: ${({ theme }) => theme.smallDesktopBreakpoint}) {
    font-size: 24px;
  }
  @media (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
    margin-bottom: 20px;
  }
`;
